import React, { useEffect, useState } from "react";
import { ReportsContainer, ReportsHeading } from "./reports.styled";
import { Button, List, Spin, TabsProps, Skeleton } from "antd";
import { ReportContainer } from "../../../components";
import { useGetReportsQuery } from "src/services";
import { SmallHeadingStyled } from "src/components/custom/texts/texts.styled";
import { IReport } from "@/Interfaces/reports";
import { FlexStyled } from "src/components/registration/register-confirmation/confirmation.styled";
import { useMediaQuery } from "src/hooks";
import { getReportsPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../../pages/StrapiError";
import { _translateValue } from "../../admin-pages/translation-gestor/translateValue";

const SCREEN_NAME = "PantallaReports";

const Reports = () => {
  const { data: reports, isLoading: isLoadingReports } = useGetReportsQuery("", {
    refetchOnMountOrArgChange: true,
  });
  const { locale } = useLocale();
  const [reportsPage, setReportsPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  const [activeReport, setActiveReport] = useState<IReport>();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [translatedData, setTranslatedData] = React.useState<{
    reportes: { [key: string]: string };
  }>({
    reportes: {},
  });

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setReportsPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getReportsPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setReportsPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setReportsPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  // Efecto para traducir los campos traducibles cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      const hasData = reports?.data && Array.isArray(reports.data) && reports.data.length > 0;
      if (!hasData) {
        setTranslatedData({ reportes: {} });
        return;
      }

      const reportesTranslations: { [key: string]: string | null } = {};
      const translationPromises: Promise<void>[] = [];

      reports.data.forEach((report: IReport) => {
        if (report.reporteNombre && !reportesTranslations.hasOwnProperty(report.reporteNombre)) {
          reportesTranslations[report.reporteNombre] = null;
          translationPromises.push(
            _translateValue(SCREEN_NAME, report.reporteNombre, locale).then((translated) => {
              reportesTranslations[report.reporteNombre] = translated;
            })
          );
        }
      });

      await Promise.all(translationPromises);
      setTranslatedData({
        reportes: reportesTranslations as { [key: string]: string },
      });
    };
    translateData();
  }, [reports?.data, locale]);

  const items: TabsProps["items"] = React.useMemo(() => {
    return reports?.data?.map((report: IReport) => ({
      key: `${report.reporteId}`,
      label: translatedData.reportes[report.reporteNombre] || report.reporteNombre,
    }));
  }, [reports?.data, translatedData.reportes]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setReportsPage(null);
      }}
    />;
  }

  return (
    <ReportsContainer>
      <Spin spinning={isLoadingReports} size="large">
        <div>
          <ReportsHeading level={2}>
            {isLoadingContent ? (
              <Skeleton.Input active size="large" style={{ width: 200 }} />
            ) : (
              reportsPage?.title || "Reportes"
            )}
          </ReportsHeading>
          <SmallHeadingStyled style={{ fontSize: 16 }}>
            {activeReport?.reporteNombre ? (translatedData.reportes[activeReport.reporteNombre] || activeReport.reporteNombre) : items?.find((item) => item.key == `${activeReport?.reporteId}`)?.label}
          </SmallHeadingStyled>
        </div>
        <FlexStyled style={{ justifyContent: "space-between" }}>
          {items && items?.length > 0 && (
            <div>
              <List
                size="small"
                header={null}
                footer={null}
                style={{ background: "white" }}
                bordered
                dataSource={items}
                renderItem={(item) => (
                  <List.Item>
                    <Button
                      style={{ width: "100%" }}
                      type="text"
                      onClick={() =>
                        setActiveReport(
                          reports?.data?.find((re: IReport) => re.reporteId == +item.key),
                        )
                      }
                    >
                      {item.label}
                    </Button>
                  </List.Item>
                )}
              />
              {/* <Form.Item label="Reporte" name="reporte">
                <Select
                  onChange={(activeKey) =>
                    setActiveReport(
                      reports?.data?.find((re: IReport) => re.reporteId == +activeKey),
                    )
                  }
                  options={items?.map((it) => ({ label: it.label, value: it.key }))}
                  placeholder="Seleccione un reporte a visualizar"
                  value={activeReport?.reporteNombre}
                  defaultValue={activeReport?.reporteNombre}
                  style={{ minWidth: "320px" }}
                />
              </Form.Item> */}
            </div>
          )}
          <div style={{ maxWidth: isMobile ? "auto" : "67%" }}>
            <ReportContainer reporte={activeReport} />,
          </div>
        </FlexStyled>
      </Spin>
    </ReportsContainer>
  );
};

export default Reports;
